import { render } from "./PacienteLayout.vue?vue&type=template&id=7523a64a"
import script from "./PacienteLayout.vue?vue&type=script&lang=js"
export * from "./PacienteLayout.vue?vue&type=script&lang=js"

import "./PacienteLayout.vue?vue&type=style&index=0&id=7523a64a&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__